import { api } from '../configs/axiosConfigs';

export const deleteFavorite = async (propertyId: string) => {
  return await api.delete(`properties/${propertyId}/favorite`);
};
